import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function ServiceTypeListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
